import axios from "axios";

const BASE_API = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

const getAuthHeaders = () => {
  const token = localStorage.getItem("eez7_client_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const registerUser = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_API}/auth/register`,
      payload
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const verifyOtp = async (email, otp, password, orgSlug) => {
  try {
    const response = await axios.post(`${BASE_API}/auth/verify-otp`, {
      email,
      otp,
      password,
      // Backend stamps the new user with this org's id so /o/:slug/login
      // passes the "belongs to this org" guard on the very first sign-in.
      orgSlug,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resendOtp = async (email) => {
  try {
    const response = await axios.post(`${BASE_API}/auth/resend-otp`, {
      email,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const loginUser = async (email, password, orgSlug) => {
  try {
    const body = { email, password };
    if (orgSlug) body.orgSlug = orgSlug;
    const response = await axios.post(`${BASE_API}/auth/login`, body);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await axios.post(`${BASE_API}/auth/forgot-password`, {
      email,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyResetOtp = async (email, otp) => {
  try {
    const response = await axios.post(`${BASE_API}/auth/verify-reset-otp`, {
      email,
      otp,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resetPassword = async (email, otp, newPassword) => {
  try {
    const response = await axios.post(`${BASE_API}/auth/reset-password`, {
      email,
      otp,
      newPassword,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resendResetOtp = async (email) => {
  try {
    const response = await axios.post(`${BASE_API}/auth/resend-reset-otp`, {
      email,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMyRatings = async () => {
  try {
    const response = await axios.get(`${BASE_API}/auth/me/ratings`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
